"use strict";
import { ProtocolVersion } from "@uniswap/client-pools/dist/pools/v1/types_pb";
import { getProtocolVersionLabel } from "components/Liquidity/utils";
export var CreatePositionRouteVariant = /* @__PURE__ */ ((CreatePositionRouteVariant2) => {
  CreatePositionRouteVariant2["FewToken"] = "fewtoken";
  return CreatePositionRouteVariant2;
})(CreatePositionRouteVariant || {});
export function parseCreatePositionRouteVariant(protocolVersionParam) {
  return protocolVersionParam?.toLowerCase() === "fewtoken" /* FewToken */ ? "fewtoken" /* FewToken */ : void 0;
}
export function getCreatePositionProtocolLabel(protocolVersion, routeVariant) {
  if (protocolVersion === ProtocolVersion.Fewv2 && routeVariant === "fewtoken" /* FewToken */) {
    return "FewToken";
  }
  return getProtocolVersionLabel(protocolVersion);
}
export function getCreatePositionSuccessPath(routeVariant, maintenanceReturnTo) {
  if (maintenanceReturnTo) {
    return maintenanceReturnTo;
  }
  return routeVariant === "fewtoken" /* FewToken */ ? "/positions/fewtoken" : "/positions";
}
